export default __webpack_public_path__ + "media/src/assets/images/right-arrow-75e22396f6cc5c7df0f8f961ac507c5f.svg";